module.exports = __webpack_public_path__ + "5a5729721280f8f2da78f83120cc508a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-1.png
// module id = 2517
// module chunks = 0